// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.23.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Javascript/Jquery helpers and utilities
// -----------------------------------------------------------------------------

const Utils = (($) => {
  let Utils = {
    setElementWidth (el, width) {
      $(el).css('width', width)
    },

    getCookie (cname) {
      const name = `${cname}=`
      const ca = document.cookie.split(';')

      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]

        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }

        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }

      return ''
    },

    /**
     * Default to 1 day lifespan for cookies
     * Pass a larger maxAge amount (of seconds) for longer lifespan.
     * @param {*} cname
     * @param {*} value
     * @param {*} [{domain = '.brinkshome.com', maxAge = '86400'}={}]
     */
    setCookie (cname, value, {domain = '.brinkshome.com', maxAge = '86400'} = {}) {
      if (cname && value) {
        document.cookie = `${cname}=${value};domain=${domain};max-age=${maxAge};`
      }
    },

    /**
     *
     * @param {*} queryString (window.location.search, e.g. "?param1=xyz&param2=lmo")
     * @param {*} name (Query string parameter name e.g. param1)
     */
    getQueryStringValue (queryString, name) {
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      const results = queryString.match(regex)
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }
  }

  return Utils
})(jQuery)

export default Utils
